const AboutZeuss = () => {
  return (
    <>
      <section className="WhatPrcog pb-0" id="about">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>About Zeuss Token</h6>
                <h4>Empowering a Decentralized Tomorrow</h4>
                <p>
                  Zeuss Token is driving innovation in decentralized
                  communication, commerce, and finance.
                </p>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-right" data-aos-duration="2000"> */}
              <div className="image">
                <img src="/images/whatzeuss.png" alt="" />
              </div>
              {/* </div> */}
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6">
              {/* <div data-aos="fade-left" data-aos-duration="2000"> */}
              <div className="content">
                <img src="/images/quote.png" alt="" />
                <h4>
                  Zeuss Token is transforming communication, commerce, and
                  finance through secure and scalable decentralized solutions,
                  empowering users worldwide.
                </h4>
                {/* <div className="label">
                  <h5>Your Name</h5>
                  <span>Co-Founder of</span>
                  <label></label>
                </div> */}
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutZeuss;
